import { render, staticRenderFns } from "./MenusList.vue?vue&type=template&id=1d512fd2&scoped=true&"
import script from "./MenusList.vue?vue&type=script&lang=js&"
export * from "./MenusList.vue?vue&type=script&lang=js&"
import style0 from "./MenusList.vue?vue&type=style&index=0&id=1d512fd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d512fd2",
  null
  
)

export default component.exports